import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, LowerCaseUrlSerializer } from './app.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LayoutModule } from './component/layout.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationModule } from './registrationComponents/registration.module';
import { UrlSerializer } from '@angular/router';
import { MedisonmedicalModule } from './MedisonMedical/medisonmedical/medisonmedical.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core'

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
   
    AppRoutingModule,
    NgxSpinnerModule,
    LayoutModule,
    
    NgbModule,
    RegistrationModule,
    
    MedisonmedicalModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
